import { type ActionContext } from 'vuex'

import { useAuthStore } from '@/auth/useAuthStore'
import { type CoreState } from '@/core/store/types'
import { OlympusClient } from '@/OlympusClient'

export const loadBrand = async (
  { commit, dispatch }: ActionContext<CoreState, unknown>,
  brandId: string
): Promise<void> => {
  const authStore = useAuthStore()

  const { brand, locations, theme, session } =
    await OlympusClient.dashboard.v2.brands.brand.core({
      headers: {
        'X-Active-Brand-ID': brandId,
      },
      params: {
        brandId,
      },
    })

  await dispatch('locations/setAll', locations)

  commit('SET_BRANDS', [brand])
  commit('SET_THEME', theme)

  if (session) await authStore.setBrandSession(session)
}
